/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IView, IViewInfo } from "../../view/IView";
import { useState } from "react";
import { useSimpleEvent } from "./useSimpleEvent";

export function useViewInfo(view: IView): IViewInfo {
	const [ viewInfo, setViewInfo ] = useState(view.getViewInfo());

	useSimpleEvent(view.onViewInfoChanged, () => {
		setViewInfo(view.getViewInfo());
	});

	return viewInfo;
}
